/* tslint:disable:one-variable-per-declaration max-line-length */
// noinspection DuplicatedCode,SpellCheckingInspection

import {Component, ElementRef, Input, OnInit, QueryList, Renderer2, ViewChild, ViewChildren} from '@angular/core';
import {FileManagerService} from '../../file-manager/file-manager.service';
import {DomSanitizer} from '@angular/platform-browser';
import {Frame} from 'scenejs';
import {MatDialog} from '@angular/material/dialog';
import {TextEditorComponent, TextEditorResult} from './text-editor/text-editor.component';
import {CollageTemplateComponent, CollageTemplateResult} from './collage-template/collage-template.component';
// tslint:disable-next-line:max-line-length
import {ContextButton, ContextEvent} from '../../tdo-shared/general-context/general-context.component';
import {
  CollageBorderColorData,
  CollageBorderComponent,
  CollageBorderRadiusData,
  CollageBorderResult,
  CollageBorderThicknessData
} from './collage-border/collage-border.component';
import {DocumentDataModel} from '../../../models/document/document-data.model';
import {NgxGalleryImage, NgxGalleryOptions} from '@tdo-inc/tdo-gallery/projects/gallery/src';

import {Globals} from '../../../globals';
import interact from 'interactjs';
import {NgxMoveableComponent} from 'ngx-moveable';
import {DocumentUploadModel} from '../../../models/document/document-upload.model';
import {CollageModel} from './models/collage.model';
import {CollagePageModel} from './models/collage-page.model';
import {CollageImageModel} from './models/collage-image.model';
import {CollageTextObjectModel} from './models/collage-text-object.model';
import {CollageTemplateModel} from './models/collage-template.model';
import dummyTemplates from './collage-template/templateDefaults/dummyTemplates.json';
//import {CollagePublishDrawerComponent} from './collage-publish-drawer/collage-publish-drawer.component';
import {CollageSizeEnum} from './models/collage-size.enum';
import {TdoDraggableImageComponent} from './collage-image/tdo-draggable-image.component';
import {DocumentClassEnum} from '../../../models/enum/document/document-class.enum';
import {DocumentFileTypeEnum} from '../../../models/enum/document/document-file-type.enum';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {TdoColorPickerEvent} from '../../../tdo-controls/common/tdo-color-picker/models/tdo-color-picker.event';
import {UiService} from '../../../services/ui.service';
import {CollageFilterModel} from './models/collage-filter.model';
import {DocumentTypeEnum} from '../../../models/enum/document/document-type.enum';

interface HTMLInputEvent extends Event {
  target: HTMLInputElement & EventTarget;
}

interface ContextMenuImagePayload {
  image: CollageImageModel;
  target: HTMLElement;
}

interface ContextMenuTextPayload {
  text: CollageTextObjectModel;
  target: HTMLElement;
}

@Component({
  standalone: false,
  selector: 'app-image-collage',
  templateUrl: './image-collage.component.html',
  styleUrls: ['./image-collage.component.scss']
})
export class ImageCollageComponent implements OnInit {

  @Input() selectedImages: DocumentDataModel[] = [];
  @Input() file: DocumentDataModel = null;
  @Input() collageID: string = null;
  @Input() showPublish: boolean = false;
  @Input() preview: boolean = false;
  @Input() screenshotData: any;
  @ViewChildren('canvas') canvases?: QueryList<ElementRef<HTMLCanvasElement>>;
  @ViewChildren('imagePlaceholder') imagePlaceholders?: QueryList<ElementRef<HTMLImageElement>>;
  @ViewChildren('moveable') moveables?: QueryList<NgxMoveableComponent>;
  @ViewChildren('target') targets?: QueryList<ElementRef<HTMLDivElement>>;
  @ViewChild('dragContainer') dragContainer?: ElementRef<HTMLDivElement>;
  @ViewChild('boundary') boundary: ElementRef;
  @ViewChild('previewImage') previewImage;
  //@ViewChild('publishDrawer') publishDrawer: CollagePublishDrawerComponent;
  @ViewChildren(TdoDraggableImageComponent) htmlImages: QueryList<TdoDraggableImageComponent>;
  collage: CollageModel = {
    collageBackground: null,
    collageSize: null,
    useBorders: false,
    labelDefaults: '',
    numberOfPages: null,
    listPages: [],
  };
  tabs: CollagePageModel[] = [];
  tab: CollagePageModel;
  images: CollageImageModel[] = [];
  selectedImage: CollageImageModel;
  texts: CollageTextObjectModel[] = [];
  galleryImages: NgxGalleryImage[] = [];
  galleryOptions: NgxGalleryOptions[] = [];
  selectedTabIndex: number = 0;
  navOpen: boolean = false;
  imageURLs: string[] = [];
  isSelected: boolean = false;
  templates: CollageTemplateModel[] = [];
  backgroundPresets: string[] = ['black', 'white', 'red', 'blue', 'grey', 'darkgreen', 'yellow', 'purple'];
  selectedAspectRatio: number = 16 / 9;
  containerHeight: number = 0;
  containerWidth: number = 0;
  backgroundSize = [];
  imageLink = null;
  previews: HTMLImageElement[] = [];
  currentPatientID: any;
  currentPatientName: any;
  currentPatientCaseID: any;
  documentID: any;
  // bImageSave: any;
  message: string;
  msgTitle: string;
  documentTags: any[] = [];
  docId: any;
  // tslint:disable-next-line:variable-name
  _isWindowsEnvironment: boolean;
  imageViewer = Globals.imageViewer;
  // CONTEXT
  showContext: boolean = false;
  contextMenuBtns: ContextButton[] = [];
  contextPositionX: number = 0;
  contextPositionY: number = 0;
  timer: any = null;

  size: string = CollageSizeEnum.Size5;
  color: string = 'black';
  patientName = 'N/A';

  // tslint:disable-next-line:max-line-length
  constructor(
    private fileService: FileManagerService,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private uiService: UiService) {
  }

  async ngOnInit(): Promise<void> {

    // console.log('ImageCollageComponent: ngOnInit');
    for (const [propertyKey, propertyValue] of Object.entries(CollageSizeEnum)) {
      if (!Number.isNaN(Number(propertyKey))) {
        continue;
      }
      this.backgroundSize.push({id: propertyValue, name: propertyKey});
    }
    this.fileService.getCollageTemplates().subscribe(res => {
      // console.log('ImageCollageComponent: getCollageTemplates', res);
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < dummyTemplates.length; i++) {
        const item: CollageTemplateModel = {
          CollageTemplateID: dummyTemplates[i].CollageTemplateID,
          TemplateName: dummyTemplates[i].TemplateName,
          TemplateJSON: dummyTemplates[i].TemplateJSON,
          TemplateOrder: dummyTemplates[i].TemplateOrder,
          Description: dummyTemplates[i].Description,
          TemplateSVGIcon: dummyTemplates[i].TemplateSVGIcon,
          xauditDeleted: null,
          xauditCreatedBy: null,
          xauditCreatedOn: null,
          xauditModifiedBy: null,
          xauditModifiedOn: null,
          xauditTableRowID: null
        };
        this.templates.push(item);
      }
      // tslint:disable-next-line:prefer-for-of
      if (res){
        for (let i = 0; i < res.length; i++) {
          const item: CollageTemplateModel = {
            CollageTemplateID: res[i].CollageTemplateID,
            TemplateName: res[i].TemplateName,
            TemplateJSON: res[i].TemplateJSON,
            TemplateOrder: res[i].TemplateOrder,
            Description: res[i].Description,
            TemplateSVGIcon: res[i].TemplateSVGIcon,
            xauditDeleted: res[i].xauditDeleted,
            xauditCreatedBy: res[i].xauditCreatedBy,
            xauditCreatedOn: res[i].xauditCreatedOn,
            xauditModifiedBy: res[i].xauditModifiedBy,
            xauditModifiedOn: res[i].xauditModifiedOn,
            xauditTableRowID: res[i].xauditTableRowID
          };
          this.templates.push(item);
        }
      }
    });
    /*const newTab: CollagePageModel = {
      tabName: '+',
      index: this.selectedTabIndex,
      listOfTextObjects: [],
      listOfImages: [],
    };*/
    this.selectedImages = JSON.parse(localStorage.getItem('open-in-collage') || '[]');
    // console.log('ImageCollageComponent: selectedImages', this.selectedImages);
    const images = this.selectedImages.map(o => this.fileService.getCollageUrl(o.PatientId, o.DocumentFileName));
    this.imageURLs = await Promise.all(images);
    // console.log('ImageCollageComponent: imageURLs', this.imageURLs);
    // remove from local storage - commented out while I test so I don't have to keep reopening window
    localStorage.removeItem('open-in-collage');

    // // interactJS - image edit functions - rotate has issues
    // function getDragAngle(event) {
    //   const box = event.element.getElementsByClassName('selectedImage');
    //   const startAngle = parseFloat(box.getAttribute('data-angle')) || 0;
    //   const center = {
    //     x: parseFloat(box.getAttribute('data-center-x')) || 0,
    //     y: parseFloat(box.getAttribute('data-center-y')) || 0
    //   };
    //   const angle = Math.atan2(center.y,
    //     center.x);
    //   return angle - startAngle;
    // }
    //
    // resize-move
    function dragMoveListener(event) {
      const target = event.target,
        // keep the dragged position in the data-x/data-y attributes
        x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
        y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
      // translate the element
      const angle = parseFloat(target.getAttribute('data-angle')) || 0;
      target.style.webkitTransform =
        target.style.transform =
          'translate(' + x + 'px, ' + y + 'px) rotate(' + angle + 'deg)';
      // update the position
      target.setAttribute('data-x', x);
      target.setAttribute('data-y', y);
    }

    // Resize and drag
    interact('.resize-drag')
      .draggable({
        onmove: dragMoveListener
      })
      .resizable({
        edges: {left: true, right: true, bottom: true, top: true},
        modifiers: [
          interact.modifiers.aspectRatio({
            ratio: 'preserve',
          }),
        ],
      })
      .on('resizemove', event => {
        // tslint:disable-next-line:prefer-const
        let target = event.target,
          x = (parseFloat(target.getAttribute('data-x')) || 0),
          y = (parseFloat(target.getAttribute('data-y')) || 0);
        // update the element style
        target.style.width = event.rect.width + 'px';
        target.style.height = event.rect.height + 'px';
        // translate when resizing from top or left edges
        x += event.deltaRect.left;
        y += event.deltaRect.top;
        target.style.webkitTransform = target.style.transform =
          'translate(' + x + 'px,' + y + 'px)';
        target.setAttribute('data-x', x);
        target.setAttribute('data-y', y);
      });

    // old team code -canvas for images, edited by Summer to pull selectedImages
    // console.log("ImageCollageComponent: ngOnInit collageID: ", this.collageID);
    if (this.collageID !== null && this.collageID !== undefined) {
      if (this.collageID.trim() !== '') {
        const collagePagesResult: any = await this.fileService.getCollage(this.collageID).toPromise();
        const tabsJson: CollagePageModel[] = JSON.parse(JSON.stringify(this.toCamel(collagePagesResult)));

        const restoredTabs: CollagePageModel[] = [];
        tabsJson.forEach(o => {
          // @ts-ignore
          const restoredImages: CollageImageModel[] =
            o.listOfImages.map<CollageImageModel>(p => ({
              collagePage: p.collagePage,
              index: p.index,
              initialDraw: p.initialDraw,
              frame: new Frame(p.frame),
              canvasWidth: p.canvasWidth,
              canvasHeight: p.canvasHeight,
              imageBorder: {
                color: p.imageBorder.color,
                thickness: p.imageBorder.thickness,
                radius: p.imageBorder.radius
              },
              documentID: p.documentID,
              documentHeight: p.documentHeight,
              documentWidth: p.documentWidth,
              zoom: p.zoom,
              aspectRatio: p.aspectRatio,
              top: p.top,
              left: p.left,
              panX: p.panX,
              panY: p.panY,
              rotation: p.rotation,
              imageLabel: p.imageLabel,
              documentURL: p.documentURL,
              value: p.value,
            }));

          const restoredTexts: CollageTextObjectModel[] =
            o.listOfTextObjects.map<CollageTextObjectModel>(p => ({
              index: p.index,
              width: p.width,
              height: p.height,
              top: p.top,
              left: p.left,
              value: p.value,
              initialDraw: p.initialDraw,
              frame: p.frame,
            }));

          const restoredTab: CollagePageModel = {
            tabName: o.tabName,
            index: o.index,
            listOfImages: restoredImages,
            listOfTextObjects: restoredTexts
          };

          restoredTabs.push(restoredTab);
        });

        this.tabs = [...restoredTabs];
      }
    } else {
      const newImages: CollageImageModel[] = [];

      for (let i = 0; i < this.selectedImages.length; i++) {
        const img = new Image();
        img.onload = function(e) {
          // console.log("ImageCollageComponent: ngOnInit img load event:", e);
          // console.log("ImageCollageComponent: ngOnInit global loader: ", this);
        };
        img.src = this.imageURLs[i];
        // console.log("ImageCollageComponent: ngOnInit img.src: ", img.src);
        // console.log("ImageCollageComponent: ngOnInit img.width: ", img.width);
        // console.log("ImageCollageComponent: ngOnInit img.height: ", img.height);
        const imageAspectRatio: number = img.height / img.width;
        // console.log("ImageCollageComponent: ngOnInit imageAspectRatio: ", imageAspectRatio);
        const canvasWidth: number = 200;
        const canvasHeight: number = canvasWidth * imageAspectRatio;

        newImages.push({
          collagePage: 1,
          index: i,
          initialDraw: true,

          frame: new Frame({
            width: '0px',
            height: '0px',
            left: '0px',
            top: '0px',
            transform: {
              rotate: '0deg',
              scaleX: 1,
              scaleY: 1,
              matrix3d: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
            }
          }),
          canvasWidth,
          canvasHeight,
          imageBorder: {color: '#FFFFFF', thickness: 0, radius: 0},
          imageLabel: {
            labelText: 'Patient: ' + this.currentPatientName + ', Case: ' + this.currentPatientCaseID,
            labelStyle: {
              labelFont: 'roboto',
              labelFontSize: 14,
              labelFontColor: '#FFFFFF'
            }
          },
          documentID: this.selectedImages[i].DocumentID,
          documentHeight: img.height,
          documentWidth: img.width,
          zoom: 1,
          aspectRatio: imageAspectRatio,
          top: 20 * i,
          left: 20 * i,
          panX: 0,
          panY: 0,
          rotation: 0,
          documentURL: this.imageURLs[i],
          value: '',
        });
      }
      const firstTab: CollagePageModel = {
        tabName: 'Page 1',
        index: 0,
        listOfImages: newImages,
        listOfTextObjects: []
      };
      this.images = this.images.concat(newImages);
      // console.log("ImageCollageComponent: ngOnInit images: ", this.images);
      this.tabs = [firstTab];
      // console.log("ImageCollageComponent: ngOnInit tabs: ", this.tabs);
    }
  }

  contentSize() {
    if (this.navOpen === true) {
      return 'collage-content';
    } else {
      return 'collage-content-full';
    }
  }

  openPrevious() {
    this.navOpen = !this.navOpen;
  }

  changeSize() {
    switch (this.size) {
      case CollageSizeEnum.Size1:
        return 'boundary1';
      case CollageSizeEnum.Size2:
        return 'boundary2';
      case CollageSizeEnum.Size3:
        return 'boundary3';
      case CollageSizeEnum.Size4:
        return 'boundary4';
      case CollageSizeEnum.Size5:
        return 'boundary5';
    }
  }

  selectThis(image: CollageImageModel) {
    this.selectedImage = image;
    const objID = 'image' + image.index;
    document.getElementById(objID).style.border = 'red solid 2px';
  }

  // Old-Code This is similar to the drawImage() but it's for the initial load
  onCanvasRender(canvas: HTMLCanvasElement, image: HTMLImageElement, target: HTMLDivElement, item: CollageImageModel): void {
    const context = canvas.getContext('2d');

    canvas.width = item.canvasWidth;
    canvas.height = item.canvasHeight;
    item.top = parseFloat(image.getAttribute('data-x'));
    item.left = parseFloat(image.getAttribute('data-y'));

    let newWidth = (item.canvasWidth * item.zoom);
    let newHeight = (newWidth * item.aspectRatio);
    newWidth -= (item.imageBorder.thickness * 2);
    newHeight -= (item.imageBorder.thickness * 2);

    context.drawImage(
      image,
      item.panX + item.imageBorder.thickness,
      item.panY + item.imageBorder.thickness,
      newWidth,
      newHeight
    );

    if (item.imageBorder.thickness !== 0) {
      context.lineWidth = item.imageBorder.thickness;
      context.strokeStyle = item.imageBorder.color;

      // don't ask me why but apparently if you make a border
      // and set the offset to (0, 0) the border gets clipped
      const borderOffset = item.imageBorder.thickness / 2;
      const widthAdjustedForBorder = canvas.width - item.imageBorder.thickness;
      const heightAdjustedForBorder = canvas.height - item.imageBorder.thickness;

      context.strokeRect(borderOffset, borderOffset, widthAdjustedForBorder, heightAdjustedForBorder);
    }

    if (item.initialDraw) {
      const top = 15 + (item.index * 15);
      const left = 15 + (item.index * 15);

      item.frame.set('width', `${item.canvasWidth}px`);
      item.frame.set('height', `${item.canvasHeight}px`);
      item.frame.set('top', `${top}px`);
      item.frame.set('left', `${left}px`);

      item.initialDraw = false;
    }

    target.style.cssText = item.frame.toCSS();
  }

  getImageLocation(image) {
    image.top = parseFloat(image.getAttribute('data-x'));
    image.left = parseFloat(image.getAttribute('data-y'));
  }

  getTextLocation(text) {
    text.top = parseFloat(text.getAttribute('data-x'));
    text.left = parseFloat(text.getAttribute('data-y'));
  }

  // Old-Code
  onCustomTextRender(text: CollageTextObjectModel, target: HTMLDivElement) {
    if (text.initialDraw) {
      text.initialDraw = false;
    } else {
      target.style.cssText = text.frame.toCSS();
      this.getTextLocation(text);
    }
  }

  onNewTabClick(event: MouseEvent) {
    if (this.tabs.length < 10) {
      const page = new CollagePageModel();
      page.tabName = 'Page' + (this.tabs.length + 1);
      page.index = this.tabs.length;
      page.listOfImages = [];
      page.listOfTextObjects = [];
      this.tabs.push(page);
    } else {
        this.uiService.displayMessage('Error', 'Maximum of 10 pages reached');
    }

  }


  removeTab(event: MouseEvent, tab: CollagePageModel): void {
    event.stopImmediatePropagation();
    const idx = this.tabs.findIndex(p => p === tab);
    if (idx > -1) {
      this.tabs.splice(idx, 1);
      this.selectedTabIndex = 0;
    }
  }

  selectTab(tab) {
    this.selectedTabIndex = tab.index;
  }

  getSelectedIndex(): number {
    return this.selectedTabIndex;
  }

  onTabChange(event: MatTabChangeEvent) {
    this.selectedTabIndex = event.index;
  }

  clearSelected(): void {
    this.showContext = false;
    // this.resetCanvasMove();
  }

  addTextItem(): void {
    const dialogRef = this.dialog.open(TextEditorComponent, {
      width: '805px',
      height: '725px',
      disableClose: true,
      data: {}
    });

    dialogRef.afterClosed().subscribe((result: TextEditorResult) => {
      if (result === null || result === undefined) {
        return;
      }

      const currenttexts = this.tabs[this.selectedTabIndex].listOfTextObjects;

      const newText: CollageTextObjectModel = {
        index: currenttexts.length,
        initialDraw: true,
        width: 0,
        height: 0,
        left: 0,
        top: 0,

        frame: new Frame({
          width: '0px',
          height: '0px',
          left: '0px',
          top: '0px',
          transform: {
            rotate: '0deg',
            scaleX: 1,
            scaleY: 1,
            matrix3d: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
          }
        }),
        value: this.sanitizer.bypassSecurityTrustHtml(result.value),
      };
      this.tabs[this.selectedTabIndex].listOfTextObjects.push(newText);
    });
  }

  // Old-Code - incomplete
  onRightClickImageContextEvent(event: MouseEvent, image: CollageImageModel, target: HTMLDivElement): void {
    const payLoad: ContextMenuImagePayload = {
      image,
      target
    };
    const bringImageToFrontBtn = new ContextButton('bringToFront', 'Bring to Front', false, payLoad);
    const sendImageToBackBtn = new ContextButton('sendToBack', 'Send to Back', false, payLoad);
    const rotateImage = new ContextButton('rotate', 'Rotate', false, payLoad);
    const resetImageBtn = new ContextButton('reset', 'Reset', false, payLoad);
    const deleteImageBtn = new ContextButton('delete', 'Delete', false, payLoad);
    const changeImageBorderBtn = new ContextButton('changeImageBorder', 'Change Border', false, payLoad);
    const addLabelBtn = new ContextButton('addImageLabel', 'Add Patient Label', false, payLoad);
    const swapBtn = new ContextButton('swap', 'Swap', true, payLoad);

    this.contextMenuBtns =
      [bringImageToFrontBtn, sendImageToBackBtn, rotateImage, resetImageBtn, swapBtn, deleteImageBtn, addLabelBtn, changeImageBorderBtn];
    this.contextPositionX = event.clientX;
    this.contextPositionY = event.clientY;
    this.showContext = true;
  }

  onRightClickTextContextEvent(event: MouseEvent, text: CollageTextObjectModel, target: HTMLDivElement): void {
    // console.log("ImageCollageComponent: onRightClickTextContextEvent text: ", text);
    const payLoad: ContextMenuTextPayload = {
      text,
      target
    };
    const bringTextToFrontBtn = new ContextButton('bringToFront', 'Bring to Front', false, payLoad);
    const sendTextToBackBtn = new ContextButton('sendToBack', 'Send to Back', false, payLoad);
    // const rotateText = new ContextButton('rotate', 'Rotate', false, payLoad);
    const resetTextBtn = new ContextButton('reset', 'Reset', false, payLoad);
    const deleteTextBtn = new ContextButton('delete', 'Delete', false, payLoad);
    const editTextBtn = new ContextButton('editText', 'Edit Text', false, payLoad);

    this.contextMenuBtns = [bringTextToFrontBtn, sendTextToBackBtn, resetTextBtn, deleteTextBtn, editTextBtn];
    this.contextPositionX = event.clientX;
    this.contextPositionY = event.clientY;
    this.showContext = true;
  }

  handleImageContextEvent(event: ContextEvent): void {
    if (event.eventType === 'close') {
      this.showContext = false;
      return;
    }
    switch (event.eventIdentifier) {
      case 'bringToFront':
        this.handleImageBringToFront(event.eventPayload);
        break;
      case 'sendToBack':
        this.handleImageSendToBack(event.eventPayload);
        break;
      case 'reset':
        this.handleImageReset(event.eventPayload);
        break;
      case 'rotate':
        this.rotateImage(event.eventPayload);
        break;
      case 'addImageLabel':
        this.addImageLabel(event.eventPayload);
        break;
      case 'delete':
        this.handleImageDelete(event.eventPayload);
        break;
      case 'swap':
        break;
      case 'changeImageBorder':
        this.handleImageChangeBorder(event.eventPayload);
        break;
      default:
        break;
    }
    this.showContext = false;
  }

  handleTextContextEvent(event: ContextEvent): void {
    if (event.eventType === 'close') {
      this.showContext = false;
      return;
    }

    switch (event.eventIdentifier) {
      case 'bringToFront':
        this.handleTextBringToFront(event.eventPayload);
        break;
      case 'sendToBack':
        this.handleTextSendToBack(event.eventPayload);
        break;
      // case 'rotate':
      //   this.rotateText(event.eventPayload);
      //   break;
      case 'reset':
        this.handleTextReset(event.eventPayload);
        break;
      case 'delete':
        this.handleTextDelete(event.eventPayload);
        break;
      case 'editText':
        this.handleTextEdit(event.eventPayload);
        break;
      default:
        break;
    }
    this.showContext = false;
  }

  // was pulling from dummy data array in constants of collage ID desc + image URLs, no actual functionality)
  openTemplate() {

    const dialogRef = this.dialog.open(CollageTemplateComponent, {
      width: '805px',
      height: '725px',
      disableClose: true,
      data: {
        templates: this.templates,
        collage: this.collage = {
          collageBackground: {backgroundType: 0, color1: this.color, color2: this.color},
          collageSize: '',
          useBorders: false, // borders for template (border for images within images)
          labelDefaults: this.currentPatientID + ' Case: ' + this.currentPatientCaseID,
          numberOfPages: this.tabs.length,
          listPages: this.tabs.map(o => ({
            tabName: o.tabName,
            index: o.index,
            listOfImages: o.listOfImages.map(p => ({
              collagePage: p.collagePage,
              index: p.index,
              initialDraw: p.initialDraw,
              frame: new Frame(p.frame),
              canvasWidth: p.canvasWidth,
              canvasHeight: p.canvasHeight,
              imageBorder: p.imageBorder,
              documentID: p.documentID,
              documentHeight: p.documentHeight,
              documentWidth: p.documentWidth,
              zoom: p.zoom,
              aspectRatio: p.aspectRatio,
              top: p.top,
              left: p.left,
              panX: p.panX,
              panY: p.panY,
              rotation: p.rotation,
              imageLabel: p.imageLabel,
              documentURL: p.documentURL,
              value: p.value,
            })),
            listOfTextObjects: o.listOfTextObjects.map(p => ({
              index: p.index,
              width: p.width,
              height: p.height,
              top: p.top,
              left: p.left,
              value: p.value,
              initialDraw: p.initialDraw,
              frame: p.frame
            })),
          }))
        }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === null || result === undefined) {
        return;
      }
      const selectedTemplate: CollageTemplateModel = result.selectedTemplate;
      this.applyTemplate(selectedTemplate);
      this.tabs = [...this.tabs];
    });
  }

  applyTemplate(template: CollageTemplateModel) {
    const templateData = JSON.parse(template.TemplateJSON);
    this.size = templateData.collageSize;
    this.changeSize();

    this.collage.useBorders = templateData.hasBorders;
    this.collage.labelDefaults = templateData.hasLabels;

    if (this.tabs[0].listOfTextObjects < templateData.listOfTemplateTextObjects.length) {
      this.uiService.displayMessage('Error', 'Not Enough Text Boxes');
      this.addTextItem();
      const newArray2 = this.tabs[this.selectedTabIndex].listOfTextObjects.slice(0, templateData.listOfTemplateTextObjects.length);
      const newArray = this.tabs[this.selectedTabIndex].listOfImages.slice(0, templateData.listOfTemplateImages.length);

      for ( let i = 0; i < newArray2.length; i++) {
        const templateItem = templateData.listOfTemplateTextObjects[i];
        const text = this.tabs[this.selectedTabIndex].listOfTextObjects[i];
        text.top = templateItem.top;
        text.left = templateItem.left;
        text.width = templateItem.width;
      }
      for ( let i = 0; i < newArray.length; i++) {
        const templateItem = templateData.listOfTemplateImages[i];
        const image = this.tabs[this.selectedTabIndex].listOfImages[i];
        image.top = templateItem.top;
        image.left = templateItem.left;
        image.documentWidth = templateItem.width;
      }
    } else if (this.tabs[0].listOfImages < templateData.listOfTemplateImages.length) {
      this.uiService.displayMessage('Error', 'Not Enough Images');
    } else {
      const newArray2 = this.tabs[this.selectedTabIndex].listOfTextObjects.slice(0, templateData.listOfTemplateTextObjects.length);
      const newArray = this.tabs[this.selectedTabIndex].listOfImages.slice(0, templateData.listOfTemplateImages.length);

      for ( let i = 0; i < newArray2.length; i++) {
        const templateItem = templateData.listOfTemplateTextObjects[i];
        const text = this.tabs[this.selectedTabIndex].listOfTextObjects[i];
        text.top = templateItem.top;
        text.left = templateItem.left;
        text.width = templateItem.width;
        const target = document.getElementById('image' + text.index);
        const angle = parseFloat(target.getAttribute('data-angle')) || 0;
        target.style.transform = 'translate(' + templateItem.left + 'px, ' + templateItem.top + 'px) rotate(' + angle + 'deg)';
        // update the position
        target.setAttribute('data-x', templateItem.left);
        target.setAttribute('data-y', templateItem.top);
      }
      for ( let i = 0; i < newArray.length; i++) {
        const templateItem = templateData.listOfTemplateImages[i];
        const image = this.tabs[this.selectedTabIndex].listOfImages[i];
        image.top = templateItem.top;
        image.left = templateItem.left;
        image.documentWidth = templateItem.width;
        const target = document.getElementById('image' + image.index);
        const angle = parseFloat(target.getAttribute('data-angle')) || 0;
        target.style.transform = 'translate(' + templateItem.left + 'px, ' + templateItem.top + 'px) rotate(' + angle + 'deg)';
        // update the position
        target.setAttribute('data-x', templateItem.left);
        target.setAttribute('data-y', templateItem.top);
      }
    }
    // console.log(this.tabs);
  }



  onSaveImage(): void {

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    canvas.width = this.boundary.nativeElement.offsetWidth;
    canvas.height = this.boundary.nativeElement.offsetHeight;

    context.fillStyle = this.color;
    context.rect(0, 0, canvas.width, canvas.height);
    context.fill();

    // context.fillRect(0, 0, canvas.width, canvas.height);

    for (const img of this.htmlImages) {
      const collageImage = new Image(img.width, img.height);
      collageImage.setAttribute('crossOrigin', 'use-credentials');
      collageImage.crossOrigin = 'use-credentials';
      collageImage.src = img.getImageDataUrl();
      context.drawImage(collageImage, img.left, img.top, img.width, img.height);
    }

    const dataUrl = canvas.toDataURL('image/jpeg');
    this.screenshotData = this.sanitizer.bypassSecurityTrustUrl(dataUrl);

    const downloadLink = document.createElement('a');
    downloadLink.href = dataUrl;
    downloadLink.download = `collage_${this.currentPatientName}_${this.currentPatientCaseID}.jpg`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  async save(): Promise<void> {
    const collage = {
      collageBackground: this.color, // set up color picker for collage BG
      collageSize: this.size, // size picker to be added to template picker
      useBorders: false, // borders for template (border for images within images)
      labelDefaults: 'Patient: ' + this.currentPatientName + ', Case: ' + this.currentPatientCaseID,
      numberOfPages: this.tabs.length,
      listPages: this.tabs
    };

    // collage.listPages.pop(); // remove the + tab
    const collageJson = JSON.stringify(collage);
    const collageBlob = new Blob([collageJson], {type: 'application/json'});
    const thumbnailBlob = new Blob([this.screenshotData], {type: 'image/jpg'});
    localStorage.setItem('collageInfo', collageJson);

    // docTags: [this.currentPatientName, this.currentPatientCaseID, this.currentPatientID, 'collage', Date.now()],
    const collageDoc: DocumentUploadModel = {
      blobXml: new Blob([collageJson], {type: 'text/plain'}),
      blob: collageBlob,
      blobThumbnail: thumbnailBlob,
      docClassId: DocumentClassEnum.Original,
      docFileTypeId: DocumentFileTypeEnum.JSON,
      docTypeId: DocumentTypeEnum.CollageJSON,
      hasAnnotation: true,
      docTagIds: [],
      patientId: this.selectedImages[0].PatientId,
      patientCaseId: null,
      parentDocId: this.currentPatientCaseID,
      caseWorkItemToothIds: [],
      caseWorkItemId: '',
      folderId: null,
      thumbDocId: '',
      isSaveAsNew: true,
      documentOrder: -1,
      BlobInfo: null,
      duplicateDocId: null,
      deviceId: null,
      createDate: '',
      description: '',
      currentDocumentId: null
    };
    //this.publishDrawer.open();
    this.onSaveImage();
    try {
      this.fileService.uploadDocuments([collageDoc]).subscribe((response) => {
        // console.log(response.documents[0]);
        this.uiService.displayMessage('Success', 'Saved');
      }, error => {
        console.error(error);
        this.uiService.displayMessage('Error', 'Error uploading document');
      });
    }
    catch (e) {
      this.uiService.displayMessage('Error', e.message);
      console.error(e);
    }
  }

  goBack(): void {
    this.showPublish = false;
  }

  private toCamel(o) {
    let newO, origKey, newKey, value;
    if (o instanceof Array) {
      // tslint:disable-next-line:no-shadowed-variable
      return o.map(value => {
        if (typeof value === 'object') {
          value = this.toCamel(value);
        }
        return value;
      });
    } else {
      newO = {};
      for (origKey in o) {
        if (o.hasOwnProperty(origKey)) {
          newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
          value = o[origKey];
          if (value instanceof Array || (value !== null && value.constructor === Object)) {
            value = this.toCamel(value);
          }
          newO[newKey] = value;
        }
      }
    }
    return newO;
  }

  private drawImage(item: CollageImageModel) {
    const canvases = this.canvases.toArray();
    const imagePlaceholders = this.imagePlaceholders.toArray();
    const canvas = canvases[item.index].nativeElement;
    const context = canvas.getContext('2d');
    const image = imagePlaceholders[item.index].nativeElement;

    canvas.width = item.canvasWidth;
    canvas.height = item.canvasHeight;

    this.getImageLocation(item);

    let newWidth = (item.canvasWidth * item.zoom);
    let newHeight = (newWidth * item.aspectRatio);
    newWidth -= (item.imageBorder.thickness * 2);
    newHeight -= (item.imageBorder.thickness * 2);

    context.drawImage(
      image,
      item.panX + item.imageBorder.thickness,
      item.panY + item.imageBorder.thickness,
      newWidth,
      newHeight
    );

    if (item.imageBorder.thickness !== 0) {
      context.lineWidth = item.imageBorder.thickness;
      context.strokeStyle = item.imageBorder.color;

      // don't ask me why but apparently if you make a border
      // and set the offset to (0, 0) the border gets clipped
      const borderOffset = item.imageBorder.thickness / 2;
      const widthAdjustedForBorder = canvas.width - item.imageBorder.thickness;
      const heightAdjustedForBorder = canvas.height - item.imageBorder.thickness;

      context.strokeRect(borderOffset, borderOffset, widthAdjustedForBorder, heightAdjustedForBorder);
    }
  }

  private handleImageBringToFront(payload: ContextMenuImagePayload) {
    const {image, target} = payload;
    this.tabs[this.selectedTabIndex].listOfImages.unshift(this.tabs[this.selectedTabIndex].listOfImages.splice(this.tabs[this.selectedTabIndex].listOfImages.indexOf(image), 1)[0]);
    target.style.zIndex = String(this.tabs[this.selectedTabIndex].listOfImages.length + 1);
    console.log('bringing to front', image);
  }

  private handleTextBringToFront(payload: ContextMenuTextPayload) {
    const {text, target} = payload;
    this.tabs[this.selectedTabIndex].listOfTextObjects.unshift(this.tabs[this.selectedTabIndex].listOfTextObjects.splice(this.tabs[this.selectedTabIndex].listOfTextObjects.indexOf(text), 1)[0]);
    target.style.zIndex = String(this.tabs[this.selectedTabIndex].listOfTextObjects.length + 1);
    console.log('bringing to front', text);
  }

  private handleImageSendToBack(payload: ContextMenuImagePayload) {
    const {image, target} = payload;
    this.tabs[this.selectedTabIndex].listOfImages.push(this.tabs[this.selectedTabIndex].listOfImages.splice(this.tabs[this.selectedTabIndex].listOfImages.indexOf(image), 1)[0]);
    target.style.zIndex = String(this.tabs[this.selectedTabIndex].listOfImages.length - (this.tabs[this.selectedTabIndex].listOfImages.length + 1));
    console.log('Sending to back', image);
  }

  private handleTextSendToBack(payload: ContextMenuTextPayload) {
    const {text, target} = payload;
    this.tabs[this.selectedTabIndex].listOfTextObjects.push(this.tabs[this.selectedTabIndex].listOfTextObjects.splice(this.tabs[this.selectedTabIndex].listOfTextObjects.indexOf(text), 1)[0]);
    target.style.zIndex = String(this.tabs[this.selectedTabIndex].listOfTextObjects.length - (this.tabs[this.selectedTabIndex].listOfTextObjects.length + 1));
    console.log('Sending to back', text);
  }

  // change center after rotate = drag not working properly
  private rotateImage(payload: ContextMenuImagePayload): void {
    const {image, target} = payload;
    const newRotate = image.rotation + 90;
    const x = parseFloat(target.getAttribute('data-x')) || 0;
    const y = parseFloat(target.getAttribute('data-y')) || 0;
      // translate the element
    const angle = parseFloat(target.getAttribute('data-angle')) || 0;
    target.style.transform = 'translate(' + x + 'px, ' + y + 'px) rotate(' + newRotate + 'deg)';
      // update the position
    target.setAttribute('data-x', String(x));
    target.setAttribute('data-y', String(y));

    image.rotation = newRotate;
  }

  private handleImageReset(payload: ContextMenuImagePayload): void {
    const {image, target} = payload;
    const width: number = 350;
    const height: number = width * image.aspectRatio;
    const rotate: number = 0;

    image.canvasWidth = width;
    image.canvasHeight = height;
    image.imageBorder.color = '#FFFFFF';
    image.imageBorder.thickness = 0;
    image.imageBorder.radius = 0;
    image.rotation = rotate;

    image.zoom = 1;
    image.panX = 0;
    image.panY = 0;

    this.drawImage(image);
    image.frame.set('width', `${width}px`);
    image.frame.set('height', `${height}px`);
    image.frame.set('transform', 'rotate', `${rotate}deg`);
    target.style.zIndex = String((this.images.findIndex(o => o.index === image.index)));
    // this.setTransform(target, item);
  }

  private addImageLabel(payload: ContextMenuImagePayload) {
    const {image, target} = payload;
    const newText: CollageTextObjectModel = {
      index: this.texts.length + 1,
      initialDraw: true,
      width: 0,
      height: 0,
      left: 0,
      top: 0,
      value: image.imageLabel.labelText,
      frame: new Frame({
        width: '0px',
        height: '0px',
        left: '0px',
        top: '0px',
        transform: {
          rotate: '0deg',
          scaleX: 1,
          scaleY: 1,
          matrix3d: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
        }
      })
    };
    this.texts.unshift(newText);
  }

  private handleTextReset(payload: ContextMenuTextPayload): void {
    const {text, target} = payload;
    const width: number = 350;
    const height: number = width;
    const rotate: number = 0;

    text.width = width;
    text.height = height;

    text.frame.set('width', `${width}px`);
    text.frame.set('height', `${height}px`);
    text.frame.set('transform', 'rotate', `${rotate}deg`);
    target.style.zIndex = String((this.images.findIndex(o => o.index === text.index)));
    // this.setTransform(target, item);
  }

  private handleImageDelete(payload: ContextMenuImagePayload): void {
    const { image, target } = payload;
    const itemInTabIndex = this.tabs[this.selectedTabIndex].listOfImages.findIndex(o => o.index === image.index);
    const itemIndex = this.images.findIndex(o => o.index === image.index);

    if (itemInTabIndex !== -1) {
      this.tabs[this.selectedTabIndex].listOfImages.splice(itemInTabIndex, 1);
    }
    if (itemIndex !== -1) {
      this.images.splice(itemIndex, 1);
    }
    console.log(this.tabs[this.selectedTabIndex].listOfImages);
  }

  private handleTextDelete(payload: ContextMenuTextPayload): void {
    const {text, target} = payload;
    const itemInTabIndex = this.tabs[this.selectedTabIndex].listOfTextObjects.findIndex(o => o.index === text.index);
    const itemIndex = this.texts.findIndex(o => o.index === text.index);

    if (itemInTabIndex !== -1) {
      this.tabs[this.selectedTabIndex].listOfTextObjects.splice(itemInTabIndex, 1);
    }
    if (itemIndex !== -1) {
      this.texts.splice(itemIndex, 1);
    }
  }

  private handleTextEdit(payload: ContextMenuTextPayload) {
    const {text, target} = payload;

    const dialogRef = this.dialog.open(TextEditorComponent, {
      width: '805px',
      height: '725px',
      disableClose: true,
      data: {text}
    });

    dialogRef.afterClosed().subscribe((result: TextEditorResult) => {
      if (result === null || result === undefined) {
        return;
      }

      const newText: CollageTextObjectModel = {
        index: 1,
        initialDraw: text.initialDraw,
        width: text.width,
        height: text.height,
        left: text.left,
        top: text.top,
        frame: text.frame,
        value: this.sanitizer.bypassSecurityTrustHtml(result.value),
      };
      // currentItems.splice(this.items);
      this.texts.splice(text.index);
      this.texts.unshift(newText);
    });
  }

  private handleImageChangeBorder(payload: ContextMenuImagePayload) {
    const {image, target} = payload;
    const dialogRef = this.dialog.open(CollageBorderComponent, {
      width: '515px',
      height: '230px',
      disableClose: true,
      data: {image, target}
    });

    const colorSub = dialogRef.componentInstance.onColorChanged.subscribe((event: CollageBorderColorData) => {
      this.drawImage(event.image);
    });

    const thicknessSub = dialogRef.componentInstance.onThicknessChanged.subscribe((event: CollageBorderThicknessData) => {
      this.drawImage(event.image);
    });

    const radiusSub = dialogRef.componentInstance.onRadiusChanged.subscribe((event: CollageBorderRadiusData) => {
      this.drawImage(event.image);
    });

    dialogRef.afterClosed().subscribe((result: CollageBorderResult) => {
      if (result === null || result === undefined) {
        return;
      }
      const tabImage = this.tabs[this.selectedTabIndex].listOfImages.find(o => o.index === result.image.index);
      if (tabImage !== null && tabImage !== undefined) {
        tabImage.imageBorder.color = result.color;
        tabImage.imageBorder.thickness = result.thickness;
        tabImage.imageBorder.radius = result.radius;

        this.drawImage(tabImage);
      }
      // tslint:disable-next-line:no-shadowed-variable
      const image = this.images.find(o => o.index === result.image.index);
      if (image !== null && image !== undefined) {
        image.imageBorder.color = result.color;
        image.imageBorder.thickness = result.thickness;
        image.imageBorder.radius = result.radius;
      }
      colorSub.unsubscribe();
      thicknessSub.unsubscribe();
      radiusSub.unsubscribe();
    });
  }
  onPublishClick(event: MouseEvent) {
    //this.publishDrawer.open();
    this.onSaveImage();
  }

  onColorChange(event: TdoColorPickerEvent) {
    this.color = event.hex;
  }

  onFilterChange(event: CollageFilterModel) {

  }
}
